import React from 'react';
import { AD } from './admin.constants';
import { s } from './admin.styles';
import { ADIcon } from './ADIcon';

interface PlaygroundPanelProps {
  kind: 'prompt' | 'tool';
  canRun: boolean;
  playInput: string;
  playOutput: string;
  playStatus: { code: number; ms: number } | null;
  playRunning: boolean;
  onInputChange: (value: string) => void;
  onRun: () => void;
}

export function PlaygroundPanel({
  kind, canRun, playInput, playOutput, playStatus, playRunning, onInputChange, onRun,
}: PlaygroundPanelProps) {
  const runLabel = 'Run ' + (kind === 'prompt' ? 'prompt' : 'tool');
  const statusDotBg = playStatus ? (playStatus.code === 200 ? AD.GREEN : AD.RED) : AD.SLATE_LIGHT;
  const statusLabel = playStatus ? (playStatus.code + ' ' + (playStatus.code === 200 ? 'OK' : 'Error')) : 'Not run';
  const statusColor = playStatus ? (playStatus.code === 200 ? AD.GREEN : AD.RED) : AD.SLATE;
  const timingLabel = playStatus ? ' · ' + playStatus.ms + 'ms' : '';
  const outputBoxStyle = playStatus && playStatus.code !== 200
    ? { ...s.outputBox, background: AD.RED_BG, borderColor: AD.RED + '30' }
    : s.outputBox;

  return (
    <>
      <div style={s.playSec}>
        <div style={s.playLab}>Input</div>
        <textarea
          value={playInput}
          onChange={e => onInputChange(e.target.value)}
          style={s.playInput}
          aria-label="Playground input"
        />
        <button
          style={s.runBtn}
          aria-label={runLabel}
          onClick={canRun ? onRun : undefined}
          disabled={playRunning || !canRun}
        >
          <ADIcon name="play" size={14} color="#fff" />
          {playRunning ? 'Running...' : runLabel}
        </button>
        <div style={s.statusRow}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: statusDotBg, display: 'inline-block' }} />
          <span style={{ color: statusColor, fontWeight: 700 }}>{statusLabel}</span>
          <span>{timingLabel}</span>
        </div>
      </div>
      {playOutput && (
        <div style={s.playSec}>
          <div style={s.playLab}>Output</div>
          <div style={outputBoxStyle}>{playOutput}</div>
        </div>
      )}
    </>
  );
}
